import TheSearch from './components/TheSearch.vue';
import TheSearchAI from './components/TheSearchAI.vue';
import EventBusConfig from './config/eventBusConfig';
import router from './router';
import store, { types } from './store';
import { Vue } from './vue';
import getFrontConfig from '../common/getFrontConfig';

const {
  searchAI: {
    alwaysShowsModalOpen,
    isEnabledInFront,
    isTestParticipantEndpoint,
  },
  urls: { productShow, searchShow },
} = getFrontConfig();

/**
 * Get (asynchronously) the test A/B segment for launching the AI search
 * @returns {boolean} true or false
 */
async function getTestSegment() {
  try {
    const response = await fetch(isTestParticipantEndpoint);
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    const data = await response.json();
    return data.success && data.isTestParticipant;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error fetching test segment:', error);
    return false;
  }
}

/**
 * Initializing vuethesearch when needed.
 */
async function initTheSearch() {
  const theSearchSelectorID = 'vuethesearch';
  const vueTheSearch = document.getElementById(theSearchSelectorID);
  // If it is not found, then abort the creation of Vue instance
  // Example: Login page
  if (!vueTheSearch) return;

  const [isTestParticipant, vueData] = await Promise.all([
    getTestSegment(),
    (() => {
      const domData = document.getElementById('vuethesearch-data');
      return domData ? JSON.parse(domData.dataset.vue) : {};
    })(),
  ]);

  store.commit(types.search.setBaseUrl, searchShow);
  store.commit(types.product.init, productShow);

  window.FRONT_CONFIG.searchAI.isTestParticipant = isTestParticipant;
  window.FRONT_CONFIG.searchAI.isFrontTestEnabled = isTestParticipant;

  const vueTheSearchAIPageAttributesElement = document.querySelector(
    '#vueTheSearchAIPageAttributes'
  );
  const vueTypevueTheSearchAIPageAttributes =
    vueTheSearchAIPageAttributesElement
      ? JSON.parse(vueTheSearchAIPageAttributesElement.text)
      : null;

  // eslint-disable-next-line no-unused-vars
  const vm = new Vue({
    el: `#${theSearchSelectorID}`,
    data: vueData,
    created() {
      this.$eventBus.$on(EventBusConfig.commands.TheSearch.hide, () =>
        this.$refs.TheSearch.hide()
      );
      this.$eventBus.$on(EventBusConfig.commands.TheSearch.show, () =>
        this.$refs.TheSearch.show()
      );
      this.$eventBus.$on(EventBusConfig.commands.TheSearch.toggle, () =>
        this.$refs.TheSearch.toggle()
      );
    },
    mounted() {
      if (alwaysShowsModalOpen) this.$refs.TheSearch.show();
    },
    render(h) {
      if (isEnabledInFront || isTestParticipant) {
        return h(TheSearchAI, {
          props: {
            searchSource: this.searchSource,
            showInputSpan: isEnabledInFront && !isTestParticipant,
            vueTyperData: vueTypevueTheSearchAIPageAttributes?.vueTyperConfig,
            tooltipData: vueTypevueTheSearchAIPageAttributes?.tooltip,
          },
          ref: 'TheSearch',
        });
      }
      // Search app old UI
      return h(TheSearch, {
        props: {
          searchSource: this.searchSource,
        },
        ref: 'TheSearch',
      });
    },
    router,
    store,
  });
}

export default initTheSearch;
